[
<template>
  <!-- BEGIN CONTENT BODY -->
  <!-- BEGIN PAGE HEADER-->
  <div>
    <breadcrumb-bar :crumbs="[`${participantSingularName} Directory`]"></breadcrumb-bar>
    <!-- END PAGE HEADER-->
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="portlet light">
              <div class="portlet-title">
                <div class="caption caption-md">
                  <i class="icon-globe theme-font hide"></i>
                  <span class="caption-subject bold uppercase">{{ participantSingularName }} directory</span>
                </div>
                <span class="pull-right options-gear" @click.prevent="columnsModalShow()" v-if="user.access >= 5"><i class="icon-settings right"></i></span>
                <participant-directory-columns id="participant-directory-columns" @confirmed="saveParticipantColumns"/>
              </div>
              <div class="portlet-body">
                <form role="form" class="form-horizontal" @submit.prevent="onSubmit">
                  <div class="form-body">
                    <div class="form-group form-md-line-input has-warning">
                      <div class="col-md-12">
                        <div class="input-group">
                          <div class="input-group-control input-icon">
                            <i class="fa fa-search"></i>
                            <input type="text" placeholder="Type to search..." class="form-control" v-model="searchQuery">
                            <div class="form-control-focus"></div>
                          </div>
                          <span class="input-group-btn btn-right">
                        <button type="submit" data-style="expand-left"
                                class="btn green mt-ladda-btn ladda-button search-btn-submit-pd">
                          <span class="ladda-label">Search</span>
                        </button>
                      </span>
                        </div>
                        <active-filters class="mt-3" v-model="activeFilters" :disabled="loading" />
                      </div>
                    </div>

                    <strong>Dismissed Status Filter: </strong>&nbsp;
                    <label class="mt-checkbox mt-checkbox-outline">
                      <input type="checkbox" v-model="showDismissed"/>
                      <span></span>Show Dismissed {{ participantPluralName }}
                    </label>&nbsp;&nbsp;&nbsp;

                    <vue-good-table
                      :columns="translatedColumns"
                      :rows="rows"
                      :pagination-options="{
                        enabled: true,
                        perPageDropdown: [10, 20, 50, 100, 200, 500],
                        dropdownAllowAll: true,
                        perPage: this.serverParams.perPage,
                        setCurrentPage: this.serverParams.page
                      }"
                      mode="remote"
                      v-if="haveResults || Object.keys(serverParams.columnFilters).length !== 0 && serverParams.columnFilters.constructor === Object"
                      :totalRows="totalRecords"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                    >
                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'participant_name'">
                            <router-link :to="{ name: 'Dashboard Participant', params: { id: props.row.id } }" tag="a" class="" data-dismiss="modal"
                                         aria-hidden="true">{{ props.row.participant_name }}</router-link>
                        </span>
                        <span v-else-if="props.column.field == 'date_completed.date'">
                          {{ props.row.date_completed && props.row.date_completed.hasOwnProperty('date') ? props.row.date_completed.date : '' | formatDateModalNoTimeZone  }}
                        </span>
                        <span v-else-if="props.column.field == 'date_of_birth.date'">
                          {{ props.row.date_of_birth && props.row.date_of_birth.hasOwnProperty('date') ? props.row.date_of_birth.date : '' | formatDateModalNoTimeZone  }}
                        </span>
                        <span v-else>
                          {{props.formattedRow[props.column.field]}}
                        </span>
                      </template>
                    </vue-good-table>
                    <div class="not-found-results" v-else="">
                      <h4>Sorry, no search results were found.</h4>
                      <h5>Search Suggestions:</h5>
                      <ul>
                        <li>Check your spelling</li>
                        <li>Search by {{ participantPluralName }} Name, System ID or Organization ID</li>
                      </ul>
                    </div>
                  </div>
                </form>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import {HTTP, ERROR} from '@/http-common';
  import ParticipantDirectoryColumns from "../components/modals/ParticipantDirectoryColumns";
  import {mapGetters} from "vuex";
  import participantDisplayName from '@/mixins/participantDisplayName';
  import ActiveFilters from "../components/reusables/ActiveFilters";

  export default {
    data() {
      return {
        activeFilters: [],
        haveResults: false,
        searchQuery: '',
        participants: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: {
            field: '',
            type: '',
          },
          page: 1,
          perPage: 10
        },
        columns: null,
        rows: [],
        showDismissed: false,
        loading: false,
      }
    },
    mixins: [
      participantDisplayName
    ],
    components: {
      ActiveFilters,
      'breadcrumb-bar': Breadcrumbs,
      'participant-directory-columns': ParticipantDirectoryColumns
    },
    mounted() {
      if (!this.setActiveFiltersFromQueryParams()){
        this.onSearch();
      }
    },
    methods: {
      onSubmit(_event, filters = null, changeColumns = false) {
        if (!filters){
          filters = this.activeFilters
        }
        this.loading = true;
        const button = Ladda.create(document.querySelector('.search-btn-submit-pd'));
        button.start();
        let target = {
          keyword: this.searchQuery,
          limit: this.serverParams.perPage,
          current_page: this.serverParams.page,
          sort_by: this.serverParams.sort.field,
          sort_order: this.serverParams.sort.type,
          columns_filter: this.serverParams.columnFilters,
          notdismissed: !this.showDismissed
        };
        if (filters.length) {
          target['filters'] = filters;
        }
        HTTP.post(`search`, target)
          .then(response => {
            ERROR(response);
            if (response.status === 200) {
              this.rows = response.data.data.rows;
              this.totalRecords = response.data.data.results_num;
              if (!this.columns || changeColumns) { // set columns only if are not set - workaround for vue-good-table bug
                this.columns = response.data.data.columns;
                this.columns.map(item => {
                  if(item.hasOwnProperty('key') && item.key.startsWith('cf')) {
                    item.sortable = false;
                  }
                })
              }
              (this.rows.length > 0) ? this.haveResults = true : this.haveResults = false;
            }
            button.stop();
            this.loading = false;
          }).catch(err => {
          button.stop();
          this.loading = false;
          console.log(err);
        });
      },
      getFilters(query) {
        let filters = [];
        for (const queryKey in query) {
          filters.push({[queryKey]: query[queryKey]})
        }
        return filters;
      },
      setActiveFiltersFromQueryParams(){
        if (this.$route.params.query) {
          this.activeFilters = this.getFilters(this.$route.params.query);
          this.$router.replace({name: 'Participant Directory'});
          return true
        }
        return false
      },
      onSearch(changeColumns = false) {
        this.loading = true;
        this.onSubmit(null, this.activeFilters, changeColumns);
      },

      updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
        this.onSearch();
      },

      onPageChange(params) {
        this.updateParams({page: params.currentPage});
      },

      onPerPageChange(params) {
        this.updateParams({perPage: params.currentPerPage, page: 1});
      },

      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params[0].type,
            field: params[0].field
          },
        });
      },

      onColumnFilter(params) {
        this.updateParams(params);
      },

      columnsModalShow() {
        $('#participant-directory-columns').modal('show');
      },

      saveParticipantColumns(columns) {
        HTTP.post(`participant-directory-columns/save`, {
          columns: JSON.stringify(columns),
          context: 'participant_directory'
        })
          .then(response => {
            this.onSearch(true);
          }).catch(err => {
          console.log(err);
        });
      }
    },
    watch: {
      showDismissed: function () {
        this.onSearch();
      },
      activeFilters() {
        this.serverParams.page = 1; // reset current page on filters change
        this.onSearch();
      }
    },
    computed: {
      ...mapGetters({
        user: 'getUser'
      }),
      translatedColumns () {
        this.columns.map(column => {
          if (column.field === 'participant_name') {
            column.label = `${this.participantSingularName} Name`;
          }
        })
        return this.columns;
      }
    }
  }
</script>

<style scoped>
  .mt-checkbox {
    padding-left: 22px;
    margin-bottom: 19px;
  }

  .options-gear {
    display: inline-block;
    padding: 10px 5px;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// ParticipantDirectory.vue?0bd4dcf9